import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ErrorPriceChartFallback = () => {
  const { t } = useTranslation();
  return <Alert severity="error">{t("priceChart.error")}</Alert>;
};

export default ErrorPriceChartFallback;
